import { getSentryScope } from '@/services/sentry';
import request from '../../services/request';
import { currencies } from '@/services/currencies';
// import { CC_GATEWAYS } from '@/utils';

export const state = {
  // default settings from the default campaign that we use for all elements that still don't have their own settings
  settings: {},
  orgDetails: {},
  gateways: [],
  chariotCid: null,
  isMultiEntity: false,
  additionalDisclaimer: '',
  suggestedAddressCountry: 'US',
  ipBasedCurrency: null // Store IP-based currency for re-validation when specific campaigns load
};

export const mutations = {
  SET_DEFAULT_SETTINGS(state, newValue) {
    state.settings = newValue;
  },
  SET_ORG_DETAILS(state, newValue) {
    getSentryScope().setTag('org', newValue.name);
    state.orgDetails = newValue;
  },
  SET_GATEWAYS(state, newValue) {
    state.gateways = newValue;
  },
  SET_CHARIOT_CID(state, newValue) {
    state.chariotCid = newValue;
  },
  SET_IS_MULTI_ENTITY(state, newValue) {
    state.isMultiEntity = newValue;
  },
  SET_ADDITIONAL_DISCLAIMER(state, newValue) {
    state.additionalDisclaimer = newValue;
  },

  SET_SUGGESTED_ADDRESS_COUNTRY(state, newValue) {
    state.suggestedAddressCountry = newValue;
  },
  SET_IP_BASED_CURRENCY(state, newValue) {
    state.ipBasedCurrency = newValue;
  }
};

export const getters = {
  minimumDonationAmount(state) {
    const DEFAULT_MIN_AMOUNT = 5;
    return state.settings.minimumDonationAmount || DEFAULT_MIN_AMOUNT;
  },
  isTextLauncher(state) {
    if (!state.settings.displayOverlayButton) {
      return false;
    }
    return state.settings.buttonType === 'text';
  },
  enhancedBotProtection(state) {
    return state.settings.enhancedBotProtection;
  },
  accentTextColor(state) {
    const textColor = state.settings.themeTextColor;
    return textColor && textColor !== '#ffffff' ? textColor : state.settings.themeColor;
  }
};

export const actions = {
  init({ dispatch }) {
    dispatch('fetchPublicOrgSettings');
  },

  async fetchPublicOrgSettings({ commit, dispatch, rootState }) {
    try {
      const { data, error } = await request.get(`/public/org-settings/${rootState.orgId}`);
      if (error) {
        throw new Error(data);
      }

      commit('SET_DEFAULT_SETTINGS', data);
      commit('SET_ORG_DETAILS', { name: data.name, website: data.website });
      commit('SET_GATEWAYS', data.gateways);
      commit('SET_CHARIOT_CID', data.chariotCid);
      commit('SET_IS_MULTI_ENTITY', data.isMultiEntity);
      commit('SET_ADDITIONAL_DISCLAIMER', data.additionalDisclaimer);

      commit('SET_SUGGESTED_ADDRESS_COUNTRY', data.meta?.country);
      const DEFAULT_CURRENCY = 'USD';
      const savedCurrency = localStorage.getItem('Double.selectedCurrency');
      const currencyBasedOnIP = data.meta?.currency || DEFAULT_CURRENCY;

      // Store IP-based currency for later re-validation when specific campaigns load
      commit('SET_IP_BASED_CURRENCY', currencyBasedOnIP);

      const defaultEnabledCurrency = currencies.value.find((currency) => !data.disabledCurrencies?.includes(currency.value))?.value || DEFAULT_CURRENCY;

      // Initial currency selection based on default campaign settings
      // Priority: 1. localStorage, 2. IP-based currency, 3. default enabled currency
      // Note: This will be re-validated in campaign.js when a specific campaign loads
      let currencyToUse;
      if (savedCurrency && !data.disabledCurrencies?.includes(savedCurrency)) {
        currencyToUse = savedCurrency;
      } else {
        currencyToUse = data.disabledCurrencies?.includes(currencyBasedOnIP) ? defaultEnabledCurrency : currencyBasedOnIP;
      }

      dispatch('donation/SET_CURRENCY_ACTIONS', currencyToUse, { root: true });

      return data;
    } catch (err) {
      console.error(err);
    }
  }
};
